<style lang="scss">
@import 'assets/styles/reset.scss';
@import 'assets/styles/app.scss';
</style>

<template>
  <router-view/>
</template>

<script>


export default {
  name: 'App',
};
</script>



// WEBPACK FOOTER //
// src/App.vue